import script from "./MainView.vue?vue&type=script&setup=true&lang=js"
export * from "./MainView.vue?vue&type=script&setup=true&lang=js"

import "./MainView.vue?vue&type=style&index=0&id=490f9c2a&lang=scss&scoped=true"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-490f9c2a"]])

export default __exports__